<template>
  <TurnsForm :typeEndPoint="'adminTurnsShow'" :dataParams="this.$route.params" />
</template>
<script>
import TurnsForm from '@/components/modules/admin/turns/form'
export default {
  name: 'TurnsFormEdit',
  components: {
    TurnsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/turns/edit.vue